import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';
import RecipeDetail from './pages/RecipeDetail';
import Header from './components/Header';
import './App.css';

// Composant Layout qui gere l'affichage du Header
// Le Header est affiche sur toutes les pages sauf l'accueil
function Layout({ children }) {
    const location = useLocation();
    // On n'affiche pas le header sur la page d'accueil
    const showHeader = location.pathname !== '/';

    return (
        <>
            {showHeader && <Header />}
            {children}
        </>
    );
}

// Composant principal de l'application
function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <Layout>
                    <Routes>
                        {/* Page d'accueil */}
                        <Route path="/" element={<Home />} />

                        {/* Page de resultats de recherche */}
                        <Route path="/search" element={<SearchResults />} />

                        {/* Page de details d'une recette */}
                        <Route path="/recipe/:id" element={<RecipeDetail />} />
                    </Routes>
                </Layout>
            </div>
        </BrowserRouter>
    );
}

export default App;
